import { render } from "./OpenExam.vue?vue&type=template&id=5e1b76a7"
import script from "./OpenExam.vue?vue&type=script&lang=js"
export * from "./OpenExam.vue?vue&type=script&lang=js"

import "./OpenExam.vue?vue&type=style&index=0&id=5e1b76a7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__